<template>
  <div class="main container--fluid d-flex align-items-center justify-content-center">
    <div class="card">
      <div class="card-body">
        <div class="text-center p-5">
          <smtt-icon class="mt-10 mb-5" icon="user-inactive" color="#8E1F1F" width="100" />
          <div class="h1">{{ $t('errorPages.userNotFound') }}</div>
          <div class="h5">{{ $t('errorPages.redirectingIn') }} {{ counter }}</div>
          <app-button @click="tryAgain" class="mt-5">{{ $t('errorPages.tryAgain.label') }}</app-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/AppButton';
import store from '@/store/store';

export default {
  name: 'UserNotFoundError',
  components: { AppButton },
  props: {},
  data: ()  => {
    return {
      counter: 5
    }
  },
  methods: {
    tryAgain() {
      if (this.$keycloak.authenticated) {
        this.$keycloak.logoutFn()
      }
      
      this.$keycloak.login({
        redirectUri: store.getters.SystemUlrBase(),
      })
    }
  },
  mounted() {
    let interval = setInterval(() => {
      this.counter -= 1
      if (this.counter === 0) {
        this.tryAgain()
        clearInterval(interval)
      }
    }, 1000);
  }
}
</script>

<style scoped>
.main {
  height: 100vh;
  background-color: #fafafa;
}
</style>

